import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  setPrimaryInfo,
  displayProfileModal,
  setProfileModalPage,
} from '../../../modules/profile/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import UploadAvatarPage from '../components/UploadAvatarPage/UploadAvatarPage'

import { doPostAvatar } from '../../../controllers/Profile'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { primaryInfo, showProfileModal, profileModalPage } = profile

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
    doPostAvatar,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPrimaryInfo,
      displayProfileModal,
      setProfileModalPage,
      waitRenderServer,
      renderServer,
    },
    dispatch,
  )

const ConnectedUploadAvatarPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UploadAvatarPage)

export default ConnectedUploadAvatarPage
